import classes from 'components/widgets/myNotifications/myNotificationsWidget.module.scss';
import OverlayWithSpinner from 'components/common/OverlayWithSpinner/overlayWithSpinner';
import { WidgetWithTitle } from 'components/common/WidgetWithTitle/WidgetWithTitle';
import { useState } from 'react';
import { useQueryGetNotifications } from 'components/App/AuthenticateLayout/Header/Notification/queries/useQueryNotifications';
import { groupNotificationsByDate } from 'components/App/AuthenticateLayout/Header/Notification/Notifications.utils';
import { IGetNotificationsResponse } from 'components/App/AuthenticateLayout/Header/Notification/Notifications.types';
import SwitchComponent from 'components/common/Switch/Switch';
import NotificationGroup from 'components/App/AuthenticateLayout/Header/Notification/NotificationGroup/NotificationGroup';
import { MuiIcon } from 'components/common/muiIcon/muiIcon';

export const MyNotificationsWidget = () => {
    const componentKey = 'myNotifications';
    const [showUnread, setShowUnread] = useState(false);
    const { isLoading, data: notifications } = useQueryGetNotifications();

    const filteredList = showUnread ? notifications?.filter((item) => !item.isRead) : notifications;
    const grouped = filteredList ? groupNotificationsByDate<IGetNotificationsResponse>({ list: filteredList }) : [];
    const title = `My Notifications (${filteredList?.length ?? 0})`;

    const handleShowUnread = () => {
        setShowUnread(!showUnread);
    };

    return (
        <WidgetWithTitle
            id={componentKey}
            title={title}
            titleComponents={[
                <div className={classes.item}>
                    Only show unread <SwitchComponent checked={showUnread} onChange={handleShowUnread} />
                </div>,
            ]}
        >
            <div className={classes.notificationList}>
                {isLoading && <OverlayWithSpinner />}

                <div className={classes.list}>
                    {grouped.length === 0 && (
                        <div className={classes.emptyList}>
                            <MuiIcon icon={'message'} fontSize={'9rem'} color="#9c9c9c" />
                            No notifications yet...
                        </div>
                    )}
                    {grouped.map((group) => (
                        <NotificationGroup key={group.title} group={group} />
                    ))}
                </div>
            </div>
        </WidgetWithTitle>
    );
};
